import { CreateAlertConfigType } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Alerts/schema/AlertBuilderSchemaTypes';
import { create } from 'zustand';


interface TemplateStoreState {
  alertTemplate: Partial<CreateAlertConfigType>;
  setAlertTemplate: (alertTemplate: Partial<CreateAlertConfigType>) => void;
}

export const useTemplateStore = create<TemplateStoreState>((set, get) => ({
  alertTemplate: {},
  setAlertTemplate: (alertTemplate: Partial<CreateAlertConfigType>) => set({ alertTemplate })
}));
